import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { UncontrolledTooltip } from 'reactstrap';
import { format } from 'date-fns';
import { AdminRegionInfoDto } from '@repo/common-types';
import RegionQuickActions from './components/RegionQuickActions';
import { ColumnAlignment } from '@/common/tableData/DataTable';

export const createColumns = (
  handleEditRegion: (regionId: string) => void,
  handleDeleteRegion: (regionId: string) => void,
): ColumnDef<AdminRegionInfoDto>[] => [
  {
    id: 'actions',
    header: 'Actions',
    size: 80,
    cell: ({ row }) => (
      <RegionQuickActions
        region={row.original}
        onEdit={() => handleEditRegion(row.original.id)}
        onDelete={() => handleDeleteRegion(row.original.id)}
      />
    ),
    meta: {
      alignment: ColumnAlignment.CENTER,
    },
    enableSorting: false,
  },
  {
    header: 'Region Name',
    accessorKey: 'name',
    size: 200,
    cell: ({ row }) => {
      const tooltipId = `region-name-${row.original.id}`;
      const name = row.original.name;
      const shortId = row.original.id.slice(0, 8);

      return (
        <>
          <div className="d-flex flex-column" id={tooltipId}>
            <span className="fw-medium">{name}</span>
            <small className="text-muted">ID: {shortId}...</small>
          </div>
          <UncontrolledTooltip placement="top" target={tooltipId}>
            <div>
              <div>{name}</div>
              <div>ID: {row.original.id}</div>
            </div>
          </UncontrolledTooltip>
        </>
      );
    },
  },
  {
    header: 'Countries',
    accessorKey: 'countriesCount',
    size: 150,
    cell: ({ row }) => <span className="fw-medium">{row.original.countriesCount}</span>,
    meta: {
      alignment: ColumnAlignment.RIGHT,
    },
  },
  {
    header: 'Subdivisions',
    accessorKey: 'subdivisionsCount',
    size: 150,
    cell: ({ row }) => <span className="fw-medium">{row.original.subdivisionsCount}</span>,
    meta: {
      alignment: ColumnAlignment.RIGHT,
    },
  },
  {
    header: 'Agent Deals',
    accessorKey: 'agentDealsCount',
    size: 150,
    cell: ({ row }) => <span>{row.original.agentDealsCount}</span>,
    meta: {
      alignment: ColumnAlignment.RIGHT,
    },
  },
  {
    header: 'Created',
    accessorKey: 'createdAt',
    size: 120,
    cell: ({ row }) => {
      const date = new Date(row.original.createdAt);
      return (
        <div className="d-flex flex-column">
          <span className="fw-medium">{format(date, 'yyyy-MM-dd')}</span>
          <small className="text-muted">{format(date, 'HH:mm')}</small>
        </div>
      );
    },
    meta: {
      alignment: ColumnAlignment.LEFT,
    },
  },
];
